if (!customElements.get('mmlc-category-hub')) {
  customElements.define('mmlc-category-hub', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.input = this.querySelector('[data-hub-search]');
      this.buttons = [...this.querySelectorAll('[data-hub-group]')];
      this.status = this.querySelector('[data-hub-status]');
      this.empty = this.querySelector('[data-hub-empty-state]');
      this.clear = this.querySelector('[data-hub-clear]');
      this.more = this.querySelector('[data-hub-more-wrap]');
      this.group = 'all';
      this.limit = 24;
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
      this.normalize = normalize;
      const aliases = {
        'abbigliamento': 'vestiti clothing apparel magliette felpe cappelli calzini',
        't shirt': 'tshirt shirts maglietta magliette',
        'felpe e giacche': 'felpa giacca hoodie hoodies sweatshirt jacket jackets',
        'calzini e pantofole': 'calzino socks sock pantofola slippers slipper',
        'cappelli e sciarpe': 'cappello berretto berretti cap caps hat hats sciarpa scarf scarves foulard',
        'giochi da tavolo e gdr': 'board games roleplay ruolo rpg dadi scacchi',
        'repliche da collezione': 'replica prop props armi elmi scudi',
        'mini figure e blind box': 'minifigure minifigures mini figurine blindbox blindboxes bobble heads',
        'bambole e playset': 'bambola doll dolls playsets',
        'libri e artbook': 'libro books book artbooks',
        'gioielli e spille': 'gioiello anelli collane bracciali ciondoli pins pin',
        'casa e decorazione': 'home decor reggilibri salvadanai calamite',
        'album e figurine': 'stickers sticker adesivi',
        'accessori per action figure': 'accessorio stand supporti figure accessories',
        'veicoli e robot': 'veicolo robots vehicles',
        'masters of the universe': 'motu he man heman',
        'tmnt': 'tartarughe ninja teenage mutant ninja turtles',
        'dc comics': 'dc',
        'lord of the rings il signore degli anelli': 'lotr tolkien',
        'demon slayer kimetsu no yaiba': 'demon slayer',
        'attack on titan l attacco dei giganti shingeki no kyojin': 'aot attacco dei giganti'
      };
      const nodes = [...this.querySelectorAll('[data-hub-card]')];
      const collections = new Map(nodes.filter(card => card.dataset.hubKind !== 'brand' && card.dataset.hubEmpty !== 'true').map(card => [normalize(card.dataset.hubTitle), card]));
      nodes.forEach(card => {
        if (card.dataset.hubKind !== 'brand') return;
        const collection = collections.get(normalize(card.dataset.hubTitle));
        if (!collection) return;
        collection.dataset.hubGroups += ' brands';
        if (!/types|universes/.test(collection.dataset.hubGroups)) collection.querySelector('[data-hub-kind-label]').textContent = this.dataset.brandLabel;
        card.dataset.hubDuplicate = 'true';
      });
      this.cards = nodes.map(node => {
        const title = normalize(node.dataset.hubTitle);
        const groups = new Set(node.dataset.hubGroups.split(' '));
        return {node, title, groups, search: title + ' ' + (aliases[title] || ''), available: node.dataset.hubEmpty !== 'true' && node.dataset.hubDuplicate !== 'true', rank: groups.has('universes') ? 0 : groups.has('types') ? 1 : groups.has('brands') ? 2 : 3};
      }).sort((a, b) => a.rank - b.rank || a.title.localeCompare(b.title));
      const fragment = document.createDocumentFragment();
      this.cards.forEach(card => fragment.append(card.node));
      this.querySelector('.mmlc-directory__grid').append(fragment);
      this.querySelector('[data-hub-controls]').hidden = false;
      this.input.addEventListener('input', () => {
        clearTimeout(this.searchTimer);
        this.group = 'all';
        this.limit = 24;
        this.searchTimer = setTimeout(() => this.filter(), 100);
      }, options);
      this.buttons.forEach(button => button.addEventListener('click', () => {
        clearTimeout(this.searchTimer);
        this.group = button.dataset.hubGroup;
        this.limit = 24;
        this.filter();
      }, options));
      const reset = () => {
        clearTimeout(this.searchTimer);
        this.input.value = '';
        this.group = 'all';
        this.limit = 24;
        this.filter();
        this.input.focus({preventScroll: true});
      };
      this.clear.addEventListener('click', reset, options);
      this.querySelector('[data-hub-reset]').addEventListener('click', reset, options);
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.input.value) { event.preventDefault(); reset(); }
      }, options);
      this.querySelector('[data-hub-more]').addEventListener('click', () => {
        const previousLimit = this.limit;
        this.limit += 24;
        this.filter();
        this.matches[previousLimit]?.node.querySelector('a').focus({preventScroll: true});
      }, options);
      this.filter();
    }
    disconnectedCallback() {
      this.abort?.abort();
      clearTimeout(this.searchTimer);
      this.ready = false;
    }
    filter() {
      const words = this.normalize(this.input.value).split(' ').filter(Boolean);
      const matching = this.cards.filter(card => card.available && words.every(word => card.search.includes(word)));
      this.matches = matching.filter(card => this.group === 'all' || card.groups.has(this.group));
      const visible = new Set(this.matches.slice(0, this.limit));
      this.cards.forEach(card => { card.node.hidden = !visible.has(card); });
      this.buttons.forEach(button => {
        const group = button.dataset.hubGroup;
        const count = group === 'all' ? matching.length : matching.filter(card => card.groups.has(group)).length;
        button.setAttribute('aria-pressed', String(group === this.group));
        button.querySelector('[data-hub-count]').textContent = count;
      });
      this.status.textContent = this.matches.length === 1 ? this.dataset.oneLabel : this.dataset.countLabel.replace('[count]', String(this.matches.length));
      this.empty.hidden = this.matches.length > 0;
      this.more.hidden = this.matches.length <= this.limit;
      this.clear.hidden = this.input.value.length === 0;
    }
  });
}